module.exports = __webpack_public_path__ + "img/manage-account-icon.dd023183.svg";